import React, { useState } from "react";
import MainContent from "components/Containers/MainContent";
import SubNav from "../../../components/Navigation/SubNav";
import SubNavTab from "../../../components/Navigation/SubNavTab";
import { Assessment } from "@mui/icons-material";
import WeeklyBillingTable from "./components/WeeklyBillingTable";
import WeeklyBillingFilter from "./components/WeeklyBillingFilter";

function WeeklyBillingReportView() {
    const [tavValue, setTabValue] = useState(0);
    const handleTabChange = (event, value) => {
        setTabValue(value);
    }
    return (
        <React.Fragment>
            <SubNav
                value={tavValue}
                onChange={handleTabChange}
                tabs={[
                    <SubNavTab key="WeeklyBillingReport" label="Weekly Report" icon={<Assessment />} count={null} />,
                ]}
            />
            <MainContent>
                <WeeklyBillingFilter />
                <WeeklyBillingTable />
            </MainContent>
        </React.Fragment>
    );
}

export default WeeklyBillingReportView;
